import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import LoadingPage from "../../../../services/LoadingPage";
import IntermediateAcc from "./IntermediateAcc";
const defaultAutos = {
  MedAccounts: [],
};

export default function IntermedateCon({AutoOptionsB}) {
  
  
  const tb = {
    wait: true,
    // Branch: true,
    Users:true,
    AllMedAccounts:true,
    // AllAccountsIndex:true,
    stor: sto,
    parms: { 
        tname:"intermed" , 
        iempid: sto.empi,
        branch:sto.branchi,
        db_name:sto.db_name 
    },
  };

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb
  );

  if (fetchAll || !AutoOptions.MedAccounts ) return <LoadingPage />;

  return (
    <IntermediateAcc
      {...{
        AutoOptions: AutoOptions.MedAccounts ? AutoOptions : defaultAutos,
        isDialog:true,
        accounts:AutoOptionsB.Accindex,
        branches:AutoOptionsB.Branches ?? [],
      }}
    />
  );
}
